// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__3hTLH","Label":"Checkbox_Label__3vNN1","InputElement":"Checkbox_InputElement__2VruM","Invalid":"Checkbox_Invalid__3ePRP"};